import { render, staticRenderFns } from "./OpenCardsDueOnDate.vue?vue&type=template&id=5d61e4e6&scoped=true&"
import script from "./OpenCardsDueOnDate.vue?vue&type=script&lang=ts&"
export * from "./OpenCardsDueOnDate.vue?vue&type=script&lang=ts&"
import style0 from "./OpenCardsDueOnDate.vue?vue&type=style&index=0&id=5d61e4e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d61e4e6",
  null
  
)

export default component.exports